import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div>
      <h1>Sorry, page not found</h1>
      <Link to="/">Go to main page</Link>
    </div>
  );
};

export default NotFoundPage;
